import styled from 'styled-components';

export const ModalTitle = styled.h4`
color: #083F44;
font-family: "Jost", sans-serif;
font-size:20px;
font-weight: 600;
line-height: 30px;
text-align: center;
margin-top: 30px;
margin-bottom:20px;
 
`;
export const ModalButton = styled.div`
    display: flex;
    gap:17px;
    justify-content: center;
`;


export const ModalText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    margin-top: 15px;
    margin-bottom:20px;
`;

export const ModalImage = styled.div`
 img{
    width: auto !important;
    margin: 0 auto;
    display: block;
 }

`;